import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export interface FieldConfig extends FormlyFieldConfig {
  data?: {};
  atLeastOneRowSel?: boolean;
}
